<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 4px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
    >
      <div
        style="
          height: 40px;
          display: flex;
          font-size: 18px;
          font-weight: bold;
          align-items: center;
        "
      >
        <div style="margin-right: 10px; display: flex; align-items: center">
          <el-button type="primary" @click="Show"> 关闭</el-button>
          <span style="margin-left: 10px">
            移交任务名称： <span>{{ row.Name }}</span></span
          >
        </div>
      </div>
      <ProjectTextReport
        ref="ProjectTextReport"
        :pId="pId"
        :taskId="taskId"
         :isShowLeft="false"
         :isShowBut="false"
        v-if="isShow === true"
        style="height: calc(100% - 51px)"
      ></ProjectTextReport>
      <div
        v-loading="ProjectInfoLoading"
        class="center-box"
        v-if="isShow === false"
      >
        <el-steps :active="active" align-center finish-status="success">
          <el-step
            v-for="item in stepsList"
            :key="item.title"
            :title="item.title"
            :status="active === 4 ? 'success' : ''"
          ></el-step>
        </el-steps>
        <div class="center-info">
          <el-row
            :gutter="10"
            v-if="active == 0"
            v-loading="stepsList[0].loading"
            style="width: 100%; height: calc(100% - 60px); overflow-y: auto"
          >
            <el-col :span="4">
              <el-card class="oneInfo">
                <div class="card-title" style="">供应商数量</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info.SupplierStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}</span>
                    &nbsp; &nbsp;
                    <span class="num">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="num">{{
                      stepsList[0].Info?.TotalSupplierQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="wh100 oneInfo">
                <div class="card-title" style="">资质资料</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info
                      .SupplierProjectTypeFilesStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}提交</span>
                    &nbsp; &nbsp;
                    <span class="num">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="num">{{
                      stepsList[0].Info?.TotalSupplierProjectTypeFilesQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="wh100 oneInfo">
                <div class="card-title" style="">项目资料</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info
                      .SupplierProjectFilesStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}提交</span>
                    &nbsp; &nbsp;
                    <span class="num">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="num">{{
                      stepsList[0].Info?.TotalSupplierProjectFilesQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="wh100 oneInfo">
                <div class="card-title card-color">设备资料</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info.DeviceDocStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{
                      stepsList[0].Info?.TotalDeviceDocSubQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="wh100 oneInfo">
                <div class="card-title card-color">设备数据</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info.DeviceStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{
                      stepsList[0].Info?.TotaDeviceQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>

            <el-col :span="4">
              <el-card class="wh100 oneInfo">
                <div class="card-title card-color">配件数据</div>
                <ul class="card-textInfo">
                  <li
                    v-for="(item, index) in stepsList[0].Info
                      .DeviceAccessoryStatics"
                    :key="index"
                    class="text"
                  >
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>{{ item.TypeName }}</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{ item.Nums || 0 }}</span>
                  </li>
                </ul>
                <ul class="card-sub">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>合计</span>
                    &nbsp; &nbsp;
                    <span class="ccnum">{{
                      stepsList[0].Info?.TotalDeviceAccessoryQty || 0
                    }}</span>
                  </li>
                </ul>
              </el-card>
            </el-col>
          </el-row>
          <el-row
            v-if="active == 1"
            v-loading="stepsList[1].loading"
            style="width: 100%; height: 100%"
          >
            <div class="df wh100">
              <div
                style="width: calc(100% - 270px); height: calc(100% - 40px)"
                id="barEarchts"
              ></div>
              <el-card
                style="width: 260px; height: calc(100% - 100px)"
                class="oneInfo"
              >
                <div
                  style="
                    font-size: 18px;
                    font-weight: bold;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 60px;
                    border-bottom: 1px solid #ccc;
                  "
                >
                  数据统计
                </div>
                <ul class="textInfo" style="padding: 20px">
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>总周期：</span>
                    &nbsp; &nbsp;
                    <span class="ccnum"
                      >{{ stepsList[1].Info?.Nums || 0 }}天</span
                    >
                  </li>
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>最长用时：</span>
                    &nbsp; &nbsp;
                    <span class="ccnum"
                      >{{ stepsList[1].Info?.MaxNums || 0 }}天</span
                    >
                  </li>
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>最短用时：</span>
                    &nbsp; &nbsp;
                    <span class="ccnum"
                      >{{ stepsList[1].Info?.MinNums || 0 }}天</span
                    >
                  </li>
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>平均用时：</span>
                    &nbsp; &nbsp;
                    <span class="ccnum"
                      >{{ stepsList[1].Info?.AvgNums || 0 }}天</span
                    >
                  </li>
                  <li class="text">
                    <span style="font-size: 20px"> • </span>&nbsp;
                    <span>用时中位数：</span>
                    &nbsp; &nbsp;
                    <span class="ccnum"
                      >{{ stepsList[1].Info?.MeNums || 0 }}天</span
                    >
                  </li>
                </ul>
              </el-card>
            </div>
          </el-row>
          <el-row
            style="width: 100%; height: calc(100% - 60px); gap: 10px"
            class="oneInfo df"
            v-if="active == 2"
          >
            <el-card
              v-for="(item, index) in stepsList[2].data"
              :key="index"
              class="wh100"
              style="width: 20%; margin: 0 auto; margin-top: 10px"
              v-loading="item.loading"
              element-loading-text="检查中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.5)"
            >
              <div
                :class="[
                  'card-titleInfo',
                  item.isData === null
                    ? ''
                    : item.isData === true
                    ? 'success'
                    : 'error',
                ]"
              >
                <span>
                  <i :class="item.icon"></i>
                  <span style="margin-left: 10px">{{ item.title }}</span>
                </span>
                <span>
                  <i class="el-icon-check" v-if="item.isData === true" st></i>
                  <span style="font-size: 12px" v-if="item.isData === false"
                    >不完整</span
                  >
                  <span
                    style="font-size: 12px"
                    v-if="item.isData === null && item.loading === false"
                    >待检查</span
                  >
                </span>
              </div>
              <ul class="card-textInfo">
                <li
                  v-for="(item, index) in item?.msg || []"
                  :key="index"
                  class="text"
                >
                  <span style="font-size: 20px"> • </span>&nbsp;
                  <span>{{ item }}</span>
                  &nbsp; &nbsp;
                </li>
              </ul>
            </el-card>
          </el-row>
          <el-row style="width: 100%; height: 100%" v-if="active == 3">
            <div
              class="wh100"
              style="
                display: flex;
                justify-content: center;
                align-items: flex-start;
                gap: 20px;
                padding: 10px;
                padding-top: 60px;
              "
            >
              <el-card
                v-for="(item, index) in stepsList[3].data"
                :key="index"
                style="width: 25%"
              >
                <div style="padding: 20px; text-align: center">
                  <div style="margin-bottom: 20px">
                    <div
                      :style="` font-size: 16px;
                        font-weight: bold;
                        margin-top: 10px;
                        color: ${item.isData === true ? '#67c23a;' : ''};`"
                    >
                      <i :class="item.icon"></i>
                      锁定{{ item.title }}数据
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      margin-bottom: 15px;
                    "
                  >
                    <el-progress
                      type="circle"
                      :percentage="item.percentage"
                      :format="(percentage) => Math.round(percentage) + '%'"
                      :color="'#67c23a'"
                      :width="120"
                      :stroke-width="15"
                    ></el-progress>
                  </div>
                  <div style="font-size: 14px; margin-top: 10px">
                    <div v-if="item.isData === true" style="color: #67c23a">
                      <i class="el-icon-check"></i>
                      <span style="margin-left: 5px"
                        >已锁定 {{ item.num || 0 }} 条</span
                      >
                    </div>
                    <div
                      v-else-if="item.isData === false"
                      style="color: #f56c6c"
                    >
                      <i class="el-icon-close"></i>
                      <span style="margin-left: 5px">锁定失败</span>
                    </div>
                    <div v-else style="color: #909399">
                      <span>等待中...</span>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </el-row>
          <el-row style="width: 100%; height: 100%" v-if="active == 4">
            <div class="w100 tac" style="padding-top: 60px">
              <el-button
                class="start-but"
                type="primary"
                @click="openTextReport"
                >点击开始生成报告</el-button
              >
            </div>
            <!-- <div class="w100 tac" style="padding-top: 60px">
              <el-button
                class="start-but"
                type="primary"
                @click="SubProjectInspect"
                >点击完成移交</el-button
              >
            </div> -->
            <!-- <div
              style="
                font-weight: bold;
                text-align: center;
                margin-bottom: 20px;
                font-size: 18px;
              "
            >
              数据移交完成
            </div> -->
            <!-- <el-card
              v-for="(item, index) in stepsList[4].data"
              :key="index"
              style="width: 500px; margin: 0 auto; margin-top: 10px"
            >
              <div style="padding: 20px">
                <i :class="item.icon"> </i>&nbsp;
                <span>{{ item.title }}</span>
                &nbsp; &nbsp;
                <span>{{ item.num || 0 }}</span>
                &nbsp; &nbsp;
                <span>{{ item.unit }}</span>
              </div>
            </el-card> -->
          </el-row>
          <div class="but df jub">
            <el-button
              @click="lastStep"
              type="primary"
              style="width: 100px"
              v-if="active > 0"
              v-loading="stepsList[active].loading"
              >上一步</el-button
            >
            <span v-if="active == 0">&nbsp;</span>
            <el-button
              @click="nextStep"
              type="primary"
              style="width: 100px"
              v-if="active < 4"
              v-loading="stepsList[active].loading"
              >下一步</el-button
            >
            <!-- <el-button
              @click="successSub"
              type="primary"
              style="width: 100px"
              v-if="active == 4"
              v-loading="stepsList[active].loading"
              >完 成</el-button
            > -->
          </div>
        </div>
      </div>
    </el-card>

    <DialogReport ref="DialogReport" @successSub="Subchange"></DialogReport>
  </div>
</template>
<script>
import moment from 'moment'
import * as echarts from 'echarts'
import { Loading } from 'element-ui'
import DialogReport from '@/views/Project/ProjectTextReport/DialogReport.vue'
import ProjectTextReport from '@/views/Project/ProjectTextReport/ProjectTextReport.vue'
export default {
  data() {
    return {
      moment,
      ProjectInfoLoading: false,
      ProjectInfo: {},
      loading: false,
      backName: '',
      pId: '',
      active: 0,
      stepsList: [
        {
          title: '移交情况总结',
          state: 0,
          loading: false,
          url: '/Base_ProjectWork/Base_Project/GetProjectStatics',
          Info: {},
        },
        {
          title: '移交进程总结',
          state: 0,
          loading: false,
          url: '/Base_ProjectWork/Base_Project/GetSupplierDays',
          Info: [],
        },
        {
          title: '移交前数据检查',
          state: 0,
          loading: false,
          data: [
            {
              title: '供应商资质数据完整性检查',
              loading: false,
              isData: null,
              icon: 'el-icon-folder-opened',
              url: '/Base_ProjectWork/Base_Project/GetProjectSupplierTypeFilesStatus',
            },
            {
              title: '项目资料数据完整性检查',
              loading: false,
              icon: 'el-icon-tickets',
              isData: null,
              url: '/Base_ProjectWork/Base_Project/GetProjectSupplierFilesStatus',
            },
            {
              title: '设备数据完整性检查',
              loading: false,
              icon: 'icon-shebei icon',
              isData: null,
              url: '/Base_ProjectWork/Base_Project/GetProjectDeviceStatus',
            },
            {
              title: '配件数据完整性检查',
              icon: 'el-icon-menu',
              loading: false,
              isData: null,
              url: '/Base_ProjectWork/Base_Project/GetProjectAccessoryStatus',
            },
            {
              title: '资料审核工作完成率检查',
              loading: false,
              icon: 'el-icon-edit-outline',
              isData: null,
              url: '/Base_ProjectWork/Base_Project/GetProjectSubmitStatus',
            },
          ],
        },
        {
          title: '数据锁定',
          state: 0,
          loading: false,
          percentage: 0,
          percentagetTime: null,
          index: 0,
          data: [
            {
              title: '供应商资质',
              loading: false,
              isData: null,
              icon: 'el-icon-folder-opened',
              percentage: 0,
              percentagetTime: null,
              url: '/Base_ProjectWork/Base_Project/SaveProjectSupplierTypeFilesLock',
            },
            {
              title: '项目资料',
              loading: false,
              icon: 'el-icon-tickets',
              isData: null,
              percentage: 0,
              percentagetTime: null,
              url: '/Base_ProjectWork/Base_Project/SaveProjectSupplierFilesLock',
            },
            {
              title: '设备信息',
              loading: false,
              icon: 'icon-shebei icon',
              isData: null,
              percentage: 0,
              percentagetTime: null,
              url: '/Base_ProjectWork/Base_Project/SaveProjectDeviceLock',
            },
            {
              title: '配件信息',
              loading: false,
              icon: 'el-icon-menu',
              isData: null,
              percentage: 0,
              percentagetTime: null,
              url: '/Base_ProjectWork/Base_Project/SaveProjectAccessoryLock',
            },
          ],
        },
        {
          title: '移交完成',
          state: 0,
          loading: false,
          data: [
            {
              title: '供应商资质',
              icon: 'el-icon-folder-opened',
              num: 0,
              unit: '条',
            },
            {
              title: '项目资料',
              icon: 'el-icon-tickets',
              num: 0,
              unit: '条',
            },
            {
              title: '设备信息',
              icon: 'el-icon-s-grid',
              num: 0,
              unit: '条',
            },
            {
              title: '通用配件信息',
              icon: 'el-icon-menu',
              num: 0,
              unit: '条',
            },
          ],
        },
      ],
      barChart: null,
      isShow: null,
    }
  },
  props: {
    taskId: {
      type: String,
      default: '',
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { DialogReport, ProjectTextReport },
  methods: {
    Show() {
      this.$emit('show')
    },
    async getInfo() {
      this.ProjectInfoLoading = true
      await this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          id: this.pId,
        })

        .then((res) => {
          this.ProjectInfoLoading = false
          if (res.Success) {
            this.ProjectInfo = res.Data || {}
          }
        })
    },
    Subchange() {
      this.isShow = true
      this.$emit('successSub')
    },
    openTextReport() {
      this.$refs.DialogReport.openDialog(this.pId, this.taskId)
    },
    //完成移交
    SubProjectInspect() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: '移交完成中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      this.$http
        .post(
          `/Base_ProjectWork/project_taskhandover/CompleteTaskhandoverData?&TaskId=${this.taskId}`,
          {}
        )
        .then((res) => {
          loadingInstance.close()
          if (res.Success) {
            this.$notify.success('操作成功！该任务已开始移交')
            this.$emit('successSub')
            this.$emit('show')
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    successSub() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: '完结检查中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      this.$http
        .post(`/Base_ProjectWork/Base_Project/ProjectClosing`, {
          id: this.pId,
        })
        .then((res) => {
          loadingInstance.close()
          if (res.Success) {
            this.$notify.success('操作成功！项目已完结')
            this.$router.go(-1)
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    nextStep() {
      if (this.active == 1) {
        this.stepsList[2].data.forEach((item) => {
          this.$set(item, 'isData', null)
          this.$set(item, 'msg', [])
        })
      }
      if (this.active == 2) {
        let flag = this.stepsList[2].data.every((item) => {
          return item.isData === true
        })
        if (!flag) {
          this.$notify.error('数据检查未通过！无法进行下一步')
          return
        }
      }
      if (this.active == 3) {
        let flag = this.stepsList[3].data.every((item) => {
          return item.isData === true
        })
        if (!flag) {
          this.$notify.error('数据锁定未完成！无法进行下一步')
          return
        }
      }
      this.active++
      console.log(this.active)
      this.getDataInfo(this.active)
    },
    lastStep() {
      this.active--
      if (this.active == 2 || this.active == 3) {
        return
      }

      this.getDataInfo(this.active)
    },
    async getDataInfo(index) {
      let item = this.stepsList[index]
      if (index === 0) {
        this.stepsList[index].loading = true
        try {
          this.$http
            .post(`${item.url}?ProjectId=${this.pId}&TaskId=${this.taskId}`, {})
            .then((res) => {
              this.stepsList[index].loading = false
              if (res.Success) {
                this.stepsList[index].Info = res.Data
              } else {
                this.$notify.error(res.Msg)
              }
            })
        } catch (error) {
          this.stepsList[index].loading = false
        }
      } else if (index === 1) {
        this.stepsList[index].loading = true
        try {
          this.$http
            .post(`${item.url}?ProjectId=${this.pId}&TaskId=${this.taskId}`, {})
            .then((res) => {
              this.stepsList[index].loading = false
              if (res.Success) {
                this.stepsList[index].Info = res.Data
                // 渲染泳道图
                this.renderBarChart(
                  res.Data?.list || [],
                  res.Data?.sDate,
                  res.Data?.eDate
                )
              } else {
                this.$notify.error(res.Msg)
              }
            })
        } catch (error) {
          this.stepsList[index].loading = false
        }
      } else if (index === 2) {
        this.$nextTick(() => {
          this.getSetp2()
        })
      } else if (index === 3) {
        this.$nextTick(() => {
          this.getSetp3()
        })
      }
    },
    async getSetp3() {
      let itemData = this.stepsList[3]
      // 重置进度和索引
      itemData.index = 0

      // 清除所有之前的定时器
      itemData.data.forEach((item) => {
        if (item.percentagetTime) {
          clearInterval(item.percentagetTime)
        }
        item.percentage = 0
        item.isData = null
      })

      // 逐个处理每个数据项
      for (let i = 0; i < itemData.data.length; i++) {
        const item = itemData.data[i]
        item.loading = true
        item.percentage = 0

        // 为当前项创建平滑进度条定时器
        item.percentagetTime = setInterval(() => {
          // 如果还在加载中，平滑增加进度到90%（留10%给完成时）
          if (item.loading && item.percentage < 90) {
            item.percentage = Math.round(
              item.percentage + Math.random() * 3 + 1
            ) // 随机增加1-4，使进度更自然，并四舍五入为整数
            if (item.percentage > 90) {
              item.percentage = 90
            }
          }
        }, 50)
        // 等待一秒钟后再发起请求
        await new Promise((resolve) => setTimeout(resolve, 1000))
        try {
          const res = await this.$http.post(
            `${item.url}?ProjectId=${this.pId}&TaskId=${this.taskId}`,
            {}
          )

          // 清除当前项的进度定时器
          if (item.percentagetTime) {
            clearInterval(item.percentagetTime)
            item.percentagetTime = null
          }

          item.loading = false

          if (res.Success) {
            item.isData = true
            this.stepsList[4].data[i].num = res.Data || 0
            item.num = res.Data || 0

            // 平滑完成进度到100%
            item.percentage = 100
            // if (item.percentage < 100) {
            //   item.percentage = Math.round(item.percentage + 2) // 增加2并四舍五入为整数
            //   if (item.percentage > 100) {
            //     item.percentage = 100
            //   } else {
            //     setTimeout(finishProgress, 20)
            //   }
            // }
          } else {
            item.isData = false
            item.percentage = 0
            // 停止所有进度条
            itemData.data.forEach((it) => {
              if (it.percentagetTime) {
                clearInterval(it.percentagetTime)
              }
            })
            this.$notify.error(res.Msg || '数据不完整')
            break // 停止执行后续接口
          }
        } catch (err) {
          // 清除当前项的进度定时器
          if (item.percentagetTime) {
            clearInterval(item.percentagetTime)
            item.percentagetTime = null
          }

          item.loading = false
          item.isData = false
          item.percentage = 0

          // 停止所有进度条
          itemData.data.forEach((it) => {
            if (it.percentagetTime) {
              clearInterval(it.percentagetTime)
            }
          })
          this.$notify.error(err.Msg || '请求失败')
          break // 停止执行后续接口
        }
      }

      // 检查是否全部成功
      const allSuccess = itemData.data.every((item) => item.isData === true)
      if (allSuccess) {
        this.$notify.success('锁定完成')
      }
    },
    async getSetp2() {
      let itemData = this.stepsList[2].data
      for (const item of itemData) {
        item.loading = true
        // 等待一秒钟后再发起请求
        await new Promise((resolve) => setTimeout(resolve, 1000))
        await this.$http
          .post(`${item.url}?ProjectId=${this.pId}&TaskId=${this.taskId}`, {})
          .then((res) => {
            item.loading = false
            if (res.Success && res.Data?.flag === false) {
              item.isData = true
              this.$set(item, 'msg', res.Data?.msg || [])
            } else {
              item.isData = false
              this.$set(item, 'msg', res.Data?.msg || [])
              this.$notify.error('数据不完整')
            }
          })
          .catch((err) => {
            item.loading = false
            item.isData = false
            this.$notify.error(err.Msg || '请求失败')
          })

        if (!item.isData) {
          break
        }
      }
    },
    /**
     * 渲染甘特图方法
     * @param {Array} data - 图表数据数组，每个元素包含供应商信息和时间范围
     * @param {string} sDate - X轴最小时间范围（可选）
     * @param {string} eDate - X轴最大时间范围（可选）
     */
    renderBarChart(data, sDate, eDate) {
      // 在下次DOM更新后执行，确保元素已渲染
      this.$nextTick(() => {
        // 获取图表容器DOM元素
        const barDom = document.getElementById('barEarchts')
        // 如果容器不存在则直接返回
        if (!barDom) return

        // 销毁已存在的图表实例，避免内存泄漏
        if (this.barChart) {
          this.barChart.dispose()
        }

        // 初始化ECharts实例
        this.barChart = echarts.init(barDom)

        // 初始化Y轴数据和系列数据数组
        const yAxisData = [] // Y轴显示的供应商名称
        const seriesData = [] // 图表系列数据

        // 遍历数据数组，处理每个供应商的信息
        data.forEach((item, index) => {
          // 将供应商名称添加到Y轴数据中
          yAxisData.push(item.TypeName)

          // 计算持续天数（用于图表显示）
          const startDate = new Date(item.sDate) // 开始日期
          const endDate = new Date(item.eDate) // 结束日期
          // 计算两个日期之间的天数差
          const durationDays = (endDate - startDate) / (24 * 3600 * 1000)

          // 构造图表系列数据项
          seriesData.push({
            name: item.TypeName, // 数据项名称
            value: [
              index, // Y轴索引位置
              item.sDate, // 开始时间
              item.eDate, // 结束时间
              durationDays, // 持续天数（用于显示）
            ],
            itemStyle: {
              color: '#409eff', // 数据项颜色（统一使用蓝色）
            },
            Nums: item.Nums, // 历时天数（从原始数据中获取）
          })
        })

        // 配置ECharts图表选项
        const option = {
          // 图表标题配置
          // title: {
          //   text: '供应商移交进度甘特图', // 标题文本
          //   left: 'center', // 标题位置居中
          // },
          // 鼠标悬浮提示框配置
          tooltip: {
            appendToBody: true,
            // 自定义提示框内容格式
            formatter: function (params) {
              // 获取当前数据项
              const item = data[params.dataIndex]
              // 返回格式化的提示内容
              return `
                <div>${item.TypeName}</div>
                <div>时间: ${item.sDate} 至 ${item.eDate}</div>
                <div>历时: ${item.Nums}天</div>
              `
            },
          },
          // 图表网格配置
          grid: {
            left: 100, // 左边距（为Y轴标签留出空间）
            top: 60, // 上边距
            right: 100, // 右边距
            bottom: 50, // 下边距
            containLabel: true, // 是否包含坐标轴标签
          },
          // X轴配置（时间轴）
          xAxis: {
            type: 'time', // 时间轴类型
            min: sDate, // X轴最小值（如果提供）
            max: eDate, // X轴最大值（如果提供）
            // X轴标签配置
            axisLabel: {
              // 格式化时间显示（月/日格式）
              formatter: function (value) {
                return echarts.time.format(value, '{MM}/{dd}', false)
              },
            },
            axisLine: {
              show: true, // 显示X轴轴线
            },
            axisTick: {
              show: true, // 显示X轴刻度线
            },
          },
          // Y轴配置（类别轴）
          yAxis: {
            name: '供应商', // Y轴名称
            type: 'category', // 类别轴类型
            // Y轴标签配置
            axisLabel: {
              show: true, // 显示标签
              interval: 0, // 标签显示间隔
              lineHeight: 16, // 行高
              width: 150, // 标签宽度
              overflow: 'break', // 文本溢出处理
              // 格式化标签文本（过长则截断）
              // formatter: function (value) {
              //   return value.length > 8 ? value.substring(0, 8) + '...' : value
              // },
            },
            data: yAxisData, // Y轴数据（供应商名称）
          },
          // 图表系列配置
          series: [
            {
              type: 'custom', // 自定义图表类型
              // 自定义渲染函数
              renderItem: function (params, api) {
                // 获取Y轴索引
                const laneIndex = api.value(0)
                // 计算开始位置坐标
                const start = api.coord([api.value(1), laneIndex])
                // 计算结束位置坐标
                const end = api.coord([api.value(2), laneIndex])
                // 计算矩形高度
                const height = api.size([0, 1])[1] * 0.6

                // 创建矩形裁剪区域，防止超出图表边界
                const rectShape = echarts.graphic.clipRectByRect(
                  {
                    x: start[0], // 矩形X坐标
                    y: start[1] - height / 2, // 矩形Y坐标
                    width: end[0] - start[0], // 矩形宽度
                    height: height, // 矩形高度
                  },
                  {
                    x: params.coordSys.x, // 坐标系X坐标
                    y: params.coordSys.y, // 坐标系Y坐标
                    width: params.coordSys.width, // 坐标系宽度
                    height: params.coordSys.height, // 坐标系高度
                  }
                )

                // 获取当前数据项
                const dataIndex = params.dataIndex
                const dataItem = seriesData[dataIndex]

                // 返回渲染元素组
                return {
                  type: 'group', // 元素组类型
                  children: [
                    {
                      type: 'rect', // 矩形元素
                      shape: rectShape, // 矩形形状
                      style: api.style({
                        fill: dataItem.itemStyle.color, // 填充颜色
                        opacity: 0.8, // 透明度
                      }),
                    },
                    {
                      type: 'text', // 文本元素
                      style: {
                        text: dataItem.Nums + '天', // 显示文本（历时天数）
                        x: start[0] + (end[0] - start[0]) / 2, // 文本X坐标（居中）
                        y: start[1], // 文本Y坐标
                        fill: '#fff', // 文本颜色（白色）
                        textAlign: 'center', // 文本对齐方式
                        textVerticalAlign: 'middle', // 文本垂直对齐方式
                      },
                    },
                  ],
                }
              },
              data: seriesData, // 系列数据
              encode: {
                x: [1, 2], // X轴数据映射（开始时间和结束时间）
                y: 0, // Y轴数据映射（Y轴索引）
              },
            },
          ],
        }

        // 设置图表选项并渲染图表
        this.barChart.setOption(option)
      })
    },
  },
  mounted() {
    // 监听窗口大小变化，重新调整图表大小
    window.addEventListener('resize', () => {
      if (this.barChart) {
        this.barChart.resize()
      }
    })
  },
  async created() {
    this.pId = this.$route.query.id
    this.backName = this.$route.query.name
    this.isShow = false
    this.active = 0
    this.getDataInfo(this.active)
    // await this.getInfo()
    // if (this.ProjectInfo.ProjectStatus === 2) {
    //   this.isShow = true
    // } else {
    //   this.isShow = false
    //   this.active = 0
    //   this.getDataInfo(this.active)
    // }
  },
  computed: {},
  watch: {},
  beforeDestroy() {
    // 销毁图表实例
    if (this.barChart) {
      this.barChart.dispose()
    }
    // 清除所有进度条定时器
    if (this.stepsList[3]?.data) {
      this.stepsList[3].data.forEach((item) => {
        if (item.percentagetTime) {
          clearInterval(item.percentagetTime)
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.center-box {
  height: calc(100% - 51px);
  width: 90%;
  padding-top: 20px;
  margin: 0 auto;
  .center-info {
    width: 100%;
    height: calc(100% - 100px);
    padding-top: 10px;
    position: relative;
    overflow-y: hidden;
    overflow-x: hidden;
    .but {
      width: 100%;
      margin: 0 auto;
      text-align: right;
      position: absolute;
      bottom: 10px;
    }
  }
}
::v-deep .el-descriptions-item__label {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
::v-deep .el-descriptions-item__content {
  font-weight: bold;
  font-size: 16px;
}
::v-deep .el-descriptions__title {
  font-weight: bold;
  font-size: 18px;
}
.error {
  // color: #f56c6c;
  background: #f56c6c;
  color: #fff;
}
.success {
  // color: #67c23a;
  background: #67c23a;
  color: #fff;
}
::v-deep .el-col {
  height: 100%;
}
::v-deep .el-card__body {
  width: 100%;
  height: 100%;
  padding: 0;
}
.card-titleInfo {
  width: 100%;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #ccc;
}
.oneInfo {
  width: 100%;
  height: 100%;

  .card-title {
    width: 100%;
    height: 100px;
    background: rgb(191, 161, 112);
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-color {
    background: #67c23a;
  }
  .card-textInfo {
    padding: 10px 20px;
    height: calc(100% - 150px);
    overflow-y: auto;
    .text {
      height: 40px;
      font-size: 14px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 20px;
    }
    .num {
      color: rgb(191, 161, 112);
    }
    .ccnum {
      color: #67c23a;
    }
  }
  .card-sub {
    padding: 10px 20px;

    .text {
      border-top: 1px solid #ccc;
      height: 40px;
      font-size: 14px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 20px;
    }
    .num {
      color: rgb(191, 161, 112);
    }
    .ccnum {
      color: #67c23a;
    }
  }
}
.textInfo {
  height: calc(100% - 50px);
  overflow-y: auto;
  .text {
    // border-top: 1px solid #ccc;
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 20px;
  }
}
.start-but {
  width: 300px;
  height: 60px;
  margin-top: 60px;
  font-size: 20px;
}
</style>
